"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlHelper = void 0;
const qs = __importStar(require("qs"));
class UrlHelper {
    static parseQueryStringFromLocation(window) {
        return this.parseQueryStringFromStr(window.location.search);
    }
    static parseQueryStringFromStr(queryString) {
        if (!queryString) {
            return {};
        }
        if (!String.prototype.startsWith) {
            String.prototype.startsWith = function (searchString, position) {
                position = position || 0;
                return this.substr(position, searchString.length) === searchString;
            };
        }
        if (queryString.startsWith('?')) {
            queryString = queryString.substring(1);
        }
        const parsedObj = qs.parse(queryString, { parseArrays: true, allowDots: true });
        const normalizedObj = {};
        if (parsedObj) {
            for (const key in parsedObj) {
                if (parsedObj[key] !== undefined && parsedObj[key] !== null) {
                    normalizedObj[key] = parsedObj[key].toString();
                }
            }
        }
        return normalizedObj;
    }
    static stringifyObjToQueryString(obj) {
        if (!obj) {
            return "";
        }
        const queryString = qs.stringify(obj, { arrayFormat: 'indices', allowDots: true });
        return queryString;
    }
    static addQueryParamToStr(queryString, key, value) {
        const currentQueryStringObj = this.parseQueryStringFromStr(queryString);
        const newQueryStringObj = Object.assign(Object.assign({}, currentQueryStringObj), { [key]: value });
        const newQueryString = this.stringifyObjToQueryString(newQueryStringObj);
        return newQueryString;
    }
}
exports.UrlHelper = UrlHelper;
//# sourceMappingURL=url-helper.js.map